module.exports = __webpack_public_path__ + "static/media/answerPage5.74a18714.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPage5.png
// module id = 1727
// module chunks = 0 1